import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.4">
      <path
        d="M14.4912 6.0219L3.64359 0.918683C3.03084 0.620769 2.30872 0.723498 1.80172 1.17913C1.29351 1.63658 1.11706 2.34722 1.35152 2.98898C1.3618 3.01496 4.01704 8.00216 4.01704 8.00216C4.01704 8.00216 1.41074 12.9881 1.40168 13.0135C1.16782 13.6559 1.34608 14.3653 1.85429 14.8222C2.16913 15.1044 2.56675 15.25 2.96679 15.25C3.21394 15.25 3.4617 15.1944 3.69254 15.0814L14.4924 9.98241C15.2689 9.61803 15.7511 8.85904 15.7505 8.00155C15.7505 7.14346 15.2665 6.38448 14.4912 6.0219ZM2.4755 2.5412C2.40178 2.29042 2.55889 2.12424 2.61026 2.07711C2.66404 2.02937 2.86043 1.88132 3.11665 2.00701C3.11967 2.00822 13.9781 7.11627 13.9781 7.11627C14.1226 7.18395 14.2428 7.27943 14.3353 7.39545H5.06367L2.4755 2.5412ZM13.9775 8.88865L3.16802 13.9925C2.91119 14.1188 2.7154 13.9713 2.66162 13.9224C2.60965 13.8765 2.45254 13.7091 2.52687 13.4577L5.06609 8.60403H14.3389C14.2464 8.72187 14.1238 8.81976 13.9775 8.88865Z"
        fill="#151718"
      />
    </g>
  </svg>
);

const SendIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default SendIcon;
